export default [
  {
    path: 'accounts',
    name: 'Accounts',
    component: () => import('./views/Accounts.vue'),
  },
];